var defaultTemplates = {
  home: function home() {
    return 'Home';
  },
  separator: function separator() {
    return '>';
  }
};
export default defaultTemplates;